// Order of the minor league standings, shared by the live standings and the end-of-season title: win% desc, then run
// differential desc, then wins desc, then tid asc (deterministic). Organizations without games go last.
type Row = { tid: number; g: number; w: number; rs: number; ra: number };

export const minorPct = (r: { g: number; w: number }) => (r.g > 0 ? r.w / r.g : 0);

// Fan hype follows the affiliate's final record, never the prospect ranking.
export const minorLeagueHype = (rank: number, numTeams: number) =>
	rank <= 5 ? 0.05 : rank <= 10 ? 0.02 : rank > numTeams - 5 ? -0.03 : 0;

export const compareMinorStandings = (a: Row, b: Row) =>
	Number(b.g > 0) - Number(a.g > 0) ||
	minorPct(b) - minorPct(a) ||
	b.rs - b.ra - (a.rs - a.ra) ||
	b.w - a.w ||
	a.tid - b.tid;
